import { z } from "zod";

export const formSchema = z.object({
  name: z.string({
    required_error: "Nome é obrigatório",
    invalid_type_error: "Nome deve ser uma string",
  }),
  password: z.string({
    required_error: "Senha é obrigatório",
    invalid_type_error: "Senha deve ser uma string",
  }),
    general_company_id: z.string({
    required_error: "Centro é obrigatório",
    invalid_type_error: "Centro deve ser uma string",
  }),
  email: z
    .string({
      required_error: "E-mail é obrigatório",
      invalid_type_error: "E-mail deve ser uma string",
    })
    .email("E-mail inválido")
});
